class EInputMask {

    public isValueInvalid(value: any) {
        return (typeof value === undefined || value === undefined || value === null );
    }

    public phone(value: any) {
        if ( this.isValueInvalid(value) ) {
            return '';
        }

        const regex = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        const masked = !regex[2] ? regex[1] : '(' + regex[1] + ') ' + regex[2] + (regex[3] ? '-' + regex[3] : '');
        return masked;
    }

    public currency = (value: any, final: boolean = false) => {
        let val = ( !this.isValueInvalid(value) ) ? value.toString().replace(/[$,]/g, '') : '0.00';
        const symbol = (val === '' ) ? '' : '$';

        if ( val.indexOf('.') > -1 ) {
            const numberVal = Number(val);
            val = numberVal.toFixed(2);
        }

        let formatted = symbol + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        if (formatted.includes('.')) {
            if ((formatted.substr(formatted.indexOf('.'), formatted.length - 1)).length === 2) {
                formatted += '0';
            }
        }
        return formatted;
    }
}

export default EInputMask;


// WEBPACK FOOTER //
// ./src/Components/EInput/EInputMask.tsx